import {
  CARD_PROCESSOR_AUTH_KEY_AUTH_TYPE,
  CARD_PROCESSOR_AUTH_KEY_TOKEN
} from "../../../components/syrapayHostedForm/Constants";
import { fetchHostedFormKey } from "@codeparva/v11-tfw-api-library";
import { convertToNumber } from "../../../utilities/utils";

export const fetchCardProcessorAuthKey = async (
  amount: string | number,
  cardProcessorId: string,
  facilityId: string,
  tenantToken?: string
) => {
  const requestBody = {
    card_processor_id: cardProcessorId,
    auth_type: CARD_PROCESSOR_AUTH_KEY_AUTH_TYPE,
    amount: convertToNumber(amount)
  };

  return await fetchHostedFormKey({
    cardProcessorAuthReq: requestBody,
    facilityId,
    tenantToken
  });
};

export const fetchCardProcessorAuthKeyToken = async (
  cardProcessorId: string,
  facilityId: string,
  tenantToken?: string
) => {
  const requestBody = {
    card_processor_id: cardProcessorId,
    auth_type: CARD_PROCESSOR_AUTH_KEY_TOKEN
  };
  return await fetchHostedFormKey({
    cardProcessorAuthReq: requestBody,
    facilityId,
    tenantToken
  });
};
